export default function ({ route, store }) {
  const navigationType =
    route?.matched?.[0]?.components?.default?.extendOptions?.navigation
      ?.disableTransparency || false
  store.commit(
    'navigation/setTheme',
    navigationType === true ? 'default' : 'transparent',
  )
}
